var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPagination = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 9,
    fill: "none",
    viewBox: "0 0 18 9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8B8B8",
    d: "M14.144.626a.44.44 0 0 0-.614 0 .425.425 0 0 0 0 .606L16.452 4.5 13.53 7.768a.425.425 0 0 0 0 .606c.17.168.444.168.614 0l3.229-3.571a.425.425 0 0 0 0-.606zM3.856.626a.44.44 0 0 1 .614 0c.17.167.17.438 0 .606L1.548 4.5 4.47 7.768c.17.168.17.44 0 .606a.44.44 0 0 1-.614 0L.627 4.803a.425.425 0 0 1 0-.606zM8 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPagination);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pagination.c77434ec.svg";